// SPRT-18874 — a cancelled program takes no new invoices. Shared by the program field (flagged the moment
// a cancelled program is selected) and by validate() (refuses the save/submit) so both read identically.
export default {
  cancelledProgramMessage:
    'This program has been cancelled. Invoices cannot be submitted against a cancelled program.'
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/program-constants.js